import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import SectionTitle from "../../components/SectionTitle";
import Stepper from "./Stepper";
import axios from 'axios'; // Import axios for API requests
import { SERVER_URL } from "../../api/url";

const QuotationForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [state, setState] = useState(true);
  const [formData, setFormData] = useState({});
  const [inquiryType, setInquiryType] = useState('Student Inquiry and Quotation Request Form');
  const [message,setMessage]=useState("")
  const [error,setError]=useState("");
  const [schedule, setSchedule] = useState({
    monday: [false, false, false, false],
    tuesday: [false, false, false, false],
    wednesday: [false, false, false, false],
    thursday: [false, false, false, false],
    friday: [false, false, false, false],
    saturday: [false, false, false, false],
    sunday: [false, false, false, false],
  });
  
  const steps = state 
    ? ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5"] 
    : ["Step 1", "Step 2", "Step 3", "Step 4"];
    const submitForm = async () => {
      if(!formData.email){
        return setError("Email is required")
      }
      if(inquiryType==="Student Inquiry and Quotation Request Form"){
       if(!formData.fullname || !formData.name){
        return setError("Name is required")
       }
      }else{
        if(!formData.contactPersonName){
          return setError("Name is required")
         }
      }
      try {
        const response = await axios.post(`${SERVER_URL}/quotation/create`, {
  email:formData.email,
  type:inquiryType,
  schoolOrcampus:formData.campusName,
  schoolOrcampusAddress:formData.campusAddress,
  contentNameOrPerson:formData.contactPersonName,
  nameOfStudent:formData.fullname || formData.name ,
  ageOfStudent:formData.age,
  emailAddressOrProposalSubmissions:formData.contactEmail,
  preferredMethodOfContact:formData.preferredContact,
  numberOfStudent:formData.numberOfStudents||formData.prenumberofStudent ,
  Students:formData.number,
  selectTheLevelForWhichYouWouldLikeToInquire:formData.level,
  whichCourseAreYouInterestedIn:formData.courseOther||formData.course ,
  proficiency:formData.ageGroupOther||formData.ageGroup,
  preferredNumberOfSessions: formData.weekOther||formData.week,
  preferredCourseDuration:formData.durationOther||formData.duration ,
  preferredLearningSchedule:`${JSON.stringify(schedule)}`,
  typeOfSupportRequired:formData.requireOther ||formData.require,
  learningMode:formData.learning,
  specificLearningGoalsOrRequirements:formData.goal,
  relationshipToStudent:formData.otherRelationship ||formData.relationshipToStudent,
  howDidYouHearAboutYourFrenchTeachers:formData.hearOther||formData.hear ,
  wouldYouLikeToReceiveUpdatesAndPromotionalOffersFromYourFrenchTeachers:formData.updates,
  additionalRequirementsOrInformation:formData.question,
  additionalCommentsOrQuestions:formData.comment
  
  
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        setFormData("")
        setMessage('Form submitted successfully:', response.data?.data);
      setError("")
      } catch (error) {
        console.log(error)
        setMessage("")
        setError("Something Went Wrong")
      }
    };
  console.log(currentStep,steps.length)
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prevStep) => prevStep + 1);
    } 
    if(currentStep === steps.length - 1){
      console.log("hello")
      submitForm();
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };



  return (
    <div className="">
      <div className="row d-flex justify-content-center">
        <div className="col-11 col-lg-6">
          <SectionTitle Title="Inquiry Form" />
          <Stepper 
            steps={steps} 
            inquiryType={inquiryType} 
            setInquiryType={setInquiryType} 
            currentStep={currentStep} 
            setState={setState} 
            state={state} 
            setFormData={setFormData} 
            formData={formData}
            schedule={schedule}
            setSchedule={setSchedule}
          />
           {message && (
                <div className="alert alert-info">
                  {message}
                </div>
              )}
              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}
          <div className="d-flex gap-3">
            <button
              className="button-prev-next"
              onClick={handleBack}
              disabled={currentStep === 0}
            >
              Back
            </button>
            <button
              className="button-prev-next"
              onClick={handleNext}
             
            >
              {currentStep === steps.length - 1 ? 'Submit' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationForm;
